import React, { useEffect } from "react";
import * as R from "ramda";
import { bindInstance } from "redux-mvc";

import { connect } from "react-redux";
import { noop } from "utils/General";

import { actions, getters } from "ui-kit/Tabs";

import { DarkTab, Div, MediumTextButton } from "components/Base";
import Tooltip from "components/Global/Tooltip";

const decorate = connect(
  (state, props) => ({
    selectedTab: getters.selectedTab(state, props)
  }),
  bindInstance({
    onSelectTab: actions.setSelectedTab,
    setIniSelected: actions.setIniSelected,
    to: actions.to
  })
);

const Tabs = ({
  tabs,
  searchTerm = "",
  onClearSearch = noop,
  selectedTab = "",
  iniSelected = "",
  onSelectTab = noop,
  setIniSelected = noop,
  tabStyle = {},
  activeValidation = false,
  beforeOnClickHandler,
  to = noop,
  ...styleProps
}) => {
  useEffect(() => {
    setIniSelected({ iniSelected, tabs });
  }, [tabs]);
  return (
    <Div
      className="tabs-container ui-kit"
      display="row.flex-start.flex-end"
      {...styleProps}
    >
      {searchTerm.length
        ? [
            <DarkTab mr={4} px={3} active activeColor="neutral8">
              Results for '{searchTerm}'
            </DarkTab>,
            <MediumTextButton color="primary5" onClick={() => onClearSearch()}>
              CLEAR SEARCH
            </MediumTextButton>
          ]
        : tabs.map(t => {
            const tabProps = {
              ...tabStyle,
              ...(t.disabled
                ? {
                    cursor: "default",
                    color: "gray5"
                  }
                : {}),
              key: t.id,
              active: t.id === selectedTab,
              className: tabStyle.className
                ? `${tabStyle.className} ${
                    t.id === selectedTab ? "active-tab" : ""
                  }`
                : t.id === selectedTab
                ? "active-tab"
                : "",
              onClick:
                t.disabled || t.id === selectedTab
                  ? noop
                  : () => {
                      if (typeof beforeOnClickHandler === "function") {
                        const result = beforeOnClickHandler(t.id);
                        if (result === false) {
                          return;
                        }
                      }
                      onSelectTab(t.id);
                      const { to: url = null } = t;
                      if (url) {
                        to(url);
                      }
                    },
              "data-cy": `ui-tab-${t.title}`
            };

            return t.tooltip ? (
              <Tooltip tooltip={t.tooltip}>
                <DarkTab {...tabProps}>
                  {t.title}
                  {activeValidation && !t.isValid && (
                    <Div
                      bg={"danger7"}
                      fw={3}
                      ml={1}
                      fs={5}
                      height={5}
                      width={5}
                      bra={3}
                      mt={1}
                      style={{ alignSelf: "flex-start" }}
                    ></Div>
                  )}
                  {R.isNil(t.count) ? "" : ` (${t.count})`}
                </DarkTab>
              </Tooltip>
            ) : (
              <DarkTab {...tabProps}>
                {t.title}
                {activeValidation && !t.isValid && (
                  <Div
                    bg={"danger7"}
                    fw={3}
                    ml={1}
                    fs={5}
                    height={5}
                    width={5}
                    bra={3}
                    mt={1}
                    style={{ alignSelf: "flex-start" }}
                  ></Div>
                )}
                {R.isNil(t.count) ? "" : ` (${t.count})`}
              </DarkTab>
            );
          })}
    </Div>
  );
};

export default decorate(Tabs);
